module.exports = __webpack_public_path__ + "img/chart.7353e559.svg";